import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLtlFreight = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLtlFreight);
};
